import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { profilePath } from '../premium-profile/profile-path';

export default function RelationshipListSignIn({
  channelName,
}: {
  channelName: string;
}): JSX.Element {
  return (
    <Stack spacing={2} sx={{ p: 4, maxWidth: 480, mx: 'auto' }}>
      <Typography variant="h5">Sign in to view this list</Typography>
      <Typography>
        Member lists are available after you sign in. Public profile counts stay visible without an account.
      </Typography>
      <Button component={Link} to="/" variant="contained">
        Sign in or join
      </Button>
      <Button component={Link} to={profilePath(channelName)}>
        Back to profile
      </Button>
    </Stack>
  );
}
